import React from "react"

import { isLTPM } from "../../../../components/shared_components_registration"

export default function ShowPlaceholdersToggle({
  intl,
  viewPlaceholders,
  togglePlaceholders,
  disabled = false,
}) {
  const registration = {
    placeholders_label: (intl) =>
      isLTPM
        ? `${intl.formatMessage({
            id: "general.show",
          })}: ${intl.formatMessage({
            id: "fermmanagemet.placeholderruns.title",
            defaultMessage: "Placeholder Runs",
          })}`
        : "Placeholder Runs",
  }

  return (
    <div
      style={{
        border: "1px solid var(--lanzalake-grey)",
        borderRadius: "3px",
        padding: "5px",
        backgroundColor: "var(--lanzalake-grey-light-2)",
      }}
    >
      <div className={"form-check form-switch"} style={{ paddingTop: "2px" }}>
        <input
          type={"checkbox"}
          id={"placeholder_toggle"}
          className={"form-check-input"}
          checked={viewPlaceholders}
          disabled={disabled}
          onChange={togglePlaceholders}
        />
        <label htmlFor={"placeholder_toggle"} className={"form-check-label"} style={{ fontSize: "85%" }}>
          {registration.placeholders_label(intl)}
        </label>
      </div>
    </div>
  )
}
